export type Placement = 'collection' | 'wishlist' | 'in_transit';
export type ReadStatus = 'not_started' | 'reading' | 'finished';

export interface Author {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface Series {
  id: string;
  name: string;
  coverUrl: string | null;
  maxAmount: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface Shelf {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface Book {
  id: string;
  author: Author;
  title: string;
  placement: Placement;
  series: Series | null;
  shelf: Shelf | null;
  readStatus: ReadStatus | null;
  part: number | null;
  rating: number | null;
  comment: string | null;
  isbn: string | null;
  coverUrl: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface BookCreateInput {
  authorId?: string;
  author?: string;
  title: string;
  placement?: Placement;
  seriesId?: string | null;
  shelfId?: string | null;
  readStatus?: ReadStatus | null;
  part?: number | null;
  seriesMaxAmount?: number | null;
  rating?: number | null;
  comment?: string | null;
  isbn?: string | null;
  coverUrl?: string | null;
}

/** Id «автора из формы», ещё не сохранённого в БД — запись только при нажатии Сохранить */
export const PENDING_AUTHOR_ID = '__pending__';

export type BookUpdateInput = Partial<BookCreateInput>;

export interface ListBooksStats {
  byPlacement: Record<Placement, number>;
  byReadStatus: {
    not_started: number;
    reading: number;
    finished: number;
    unset: number;
  };
}

export interface ListBooksResponse {
  items: Book[];
  total: number;
  page: number;
  limit: number;
  stats: ListBooksStats;
}

/** Normalized book from external APIs (Google Books / Open Library) */
export interface ExternalBook {
  title: string;
  author: string;
  isbn?: string | null;
  year?: number | null;
  coverUrl?: string | null;
}
